// This module brings in the configuration that is set up for us by the host app.
// Do not access this global directly anywhere else in this guest app.
// The purpose of this module is to provide it as an object you can import where needed with type annotations.

// @ts-ignore Property 'BMT' does not exist on type 'Window & typeof globalThis'; using ignore instead of expect-error because linting doesn't recognize this as an error, even though Vite file declaration does
export default window.BMT.config;
